import { last } from "lodash";

export const getTopModalElement = () =>
  last(document.getElementById("modal_region")?.querySelectorAll(`[data-modal="true"]`));
